export default {
    SomethingWentWrong: 'Something went wrong. Please try again.',
    InternalServerError: 'Internal server error.',
    InternetConnectionError: 'We are not able to serve you at the moment, please try again after some time',
    NetworkError: 'Network Error',
    EnquirySentSuccess: `Enquiry sent successfully.`,
    NoRecordsFound: 'No records found.',
};
